<div #container [ngClass]="'z-toast p-component z-toast-' + position" [ngStyle]="style" [class]="styleClass">
  <z-toast-item
    *ngFor="let msg of messages; let i = index"
    [message]="msg"
    [index]="i"
    (open)="onMessageOpen($event)"
    (close)="onMessageClose($event)"
    @toastAnimation
    (@toastAnimation.start)="onAnimationStart($event)"
    (@toastAnimation.done)="onAnimationEnd($event)"
    [showTransformOptions]="showTransformOptions"
    [hideTransformOptions]="hideTransformOptions"
    [showTransitionOptions]="showTransitionOptions"
    [hideTransitionOptions]="hideTransitionOptions"
  ></z-toast-item>
</div>
